<template>
  <div style="background: #f6f6f6;">
    <div class="app-tab-bar">
      <!-- 标签页 -->
      <el-tabs :value="activeTabName" type="card" @tab-click="selectTab">
        <el-tab-pane
            v-for="(item, index) in navMenuTabs"
            :key="item.name"
            :label="item.name"
            :name="item.name"
        >
          <template #label>
            <div class="tab-bar-bg">
              <span
                  class="label-temp"
                  @contextmenu.prevent="fixedTab($event, item)"
              >{{ item.name }}</span
              >
              <i
                  class="el-icon-close el-icon-paperclip"
                  @click.stop="changeTabFixed(item, false)"
                  v-if="item.fixed"
              ></i>
              <i
                  class="el-icon-close"
                  @click.stop="removeTab(item.name)"
                  v-else-if="item.closable"
              ></i>
            </div>
            <!-- 分割线 -->
            <div class="divider-vertical" v-show="dividerShow(index)"></div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <div class="app-tab-bar__right">

        <gj-dropdown class="tab--close__dropdown">
          <i class="el-icon-caret-bottom"></i>
          <template #dropdown>
            <gj-dropdown-item @click="closeAllTab">关闭所有标签</gj-dropdown-item>
            <gj-dropdown-item @click="closeOtherTab"
            >关闭其它标签</gj-dropdown-item
            >
          </template>
        </gj-dropdown>
        <app-info-bar
            v-if="navStateRef === 'vertical'"
            @cutNavState="(state) => $emit('cutNavState', state)"
        ></app-info-bar>
        <!-- 鼠标右键菜单 -->
        <div
            class="mouse-menu"
            v-if="mouseMenuOptions.show"
            :style="mouseMenuStyle"
            @click="changeMouseMenuShow(false)"
            @contextmenu.prevent="changeMouseMenuShow(false)"
        >
          <div class="menu-mantle"></div>
          <div class="menu-cell" @click="refresh">刷新当前页面</div>
          <div
              class="menu-cell"
              v-show="
            mouseMenuOptions.item.name !== 'Dashboard' &&
              !mouseMenuOptions.fixed
          "
              @click="changeTabFixed(mouseMenuOptions.item, true)"
          >
            固定到任务栏
          </div>
          <div
              class="menu-cell"
              v-show="
            mouseMenuOptions.item.name !== 'Dashboard' && mouseMenuOptions.fixed
          "
              @click="changeTabFixed(mouseMenuOptions.item, false)"
          >
            解除固定任务栏
          </div>
          <div
              class="menu-cell"
              v-show="mouseMenuOptions.item.name !== 'Dashboard'"
              @click="removeTab(mouseMenuOptions.item.name)"
          >
            关闭当前页面
          </div>
        </div>
      </div>
    </div>

<!--    顶部全局通知条-->
    <global-message></global-message>

  </div>
</template>

<script>
import { defaultVal, isMeaningful, isMeaningless } from "../../../utils/common";
import {userInfoMixIn, isMeaningfulMixin, keepAliveMixin} from "@/minxins";
import MessagePopover from "../../modules/message/bar/message-popover";
import { mapGetters } from "vuex";
import { SET_KEEP_ALIVE_VIEWS, SET_NAV_MENU_TABS, SET_USER_GUIDE_STATE } from "../../../store/mutation-types";
import { PAGE_ROUTES } from "../../../utils/const";
import TtlLocalStorage from "../../../utils/storage";
import AppInfoBar from "./app-info-bar.vue";

import GlobalMessage from "./components/global-message.vue";


const storage = new TtlLocalStorage({
  namespace: "TAB_FIXED",
});

export default {
  name: "app-tab-bar",
  components: { AppInfoBar, GlobalMessage },
  mixins: [userInfoMixIn, isMeaningfulMixin, keepAliveMixin],
  props: {
    navState: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      firstRender: true, // 判断是否是首次进入
      // 鼠标右键配置
      mouseMenuOptions: {
        show: false,
        fixed: false,
        item: {},
      },
      // 鼠标菜单style配置
      mouseMenuStyle: {
        top: "0",
        left: "0",
      },
      activeTabName: "Dashboard",
      dividerShowIndex: 0,
      adSingleCallback: null,
    };
  },
  watch: {
    $route: {
      immediate: true,
      async handler(route, oldRoute) {
        // 处理页面tab栏
        const moduleRoute = route.matched[0];
        if (moduleRoute) {
          const componentName = moduleRoute.components.default.name || "";
          const navTab = this.navMenuTabs.find(
            (e) => e.name === moduleRoute.meta.name
          );
          if (this.firstRender) {
            // 添加固定的任务栏
            this.firstRender = false;
            const navTabFixed = await storage.get("FIXED");
            var flag = false; // 用在判断是否需要
            for (const iterator of navTabFixed || []) {
              this.navMenuTabs.push(iterator);
              moduleRoute.meta.name == iterator.name && (flag = true);
            }
          }
          if (isMeaningless(navTab)) {
            // 添加navTab
            if (!PAGE_ROUTES.includes(moduleRoute.path)) {
              // 非注册、登录页则设置navTab
              if (!flag && moduleRoute.meta.name) {
                // 拿到当前路由的位置
                const currentIndex = this.navMenuTabs.findIndex(item => item.path === oldRoute?.path)
                const routeData = {
                  fullPath: route.fullPath,
                  name: moduleRoute.meta.name,
                  componentName,
                  path: moduleRoute.path,
                  closable: defaultVal(moduleRoute.meta.closable, true),
                  fixed: false,
                }
                if (currentIndex > 0) {
                  this.navMenuTabs.splice(currentIndex + 1, 0, routeData)
                  // divider(标签之间的分割线)样式控制
                  this.dividerShowIndex = currentIndex + 1
                }else {
                  this.navMenuTabs.push(routeData);
                  // divider(标签之间的分割线)样式控制
                  this.dividerShowIndex = this.navMenuTabs.length - 1
                }
              }
              this.activeTabName = moduleRoute.meta.name;
            }
          } else {
            // 已存在，则激活
            this.activeTabName = navTab.name;
            // divider样式控制
            this.dividerShowIndex = this.navMenuTabs.findIndex(item => navTab.name === item.name)
          }

          if(oldRoute?.matched[0]){
            //  获取老路由所对应的index
            const currentOldIndex = this.navMenuTabs.findIndex(
                (e) => e.name === oldRoute.matched[0].meta.name
            )

            //  获取fullPath对应的index
            const tabIndex = this.navMenuTabs.findIndex(
                (e) => e.fullPath === oldRoute.fullPath
            )

            // 如果fullPath变化，则替换
            if (currentOldIndex !== -1 && tabIndex === -1) {
              this.navMenuTabs[currentOldIndex].fullPath = oldRoute.fullPath;
            }
          }

          // 设置组件缓存
          if (
            isMeaningful(componentName) &&
            !this.keepAliveViews.includes(componentName)
          ) {
            this.$nextTick(() => this.keepAliveViews.push(componentName));
          }
        }
        //跳转需要删除原来tabs页面
        if (isMeaningful(route.query) && isMeaningful(route.query.deleteTabs)) {
          this.removeTab(route.query.deleteTabs);
        }
      },
    },
  },
  computed: {
    ...mapGetters(["userMenus", "userInfo", "navMenuTabs", 'userGuideState']),
    dividerShow() {
      return index => {
        if (index === 0 && Number(this.dividerShowIndex) === 0) {
          return false
        }
        return !(index === (Number(this.dividerShowIndex) - 1))
      }
    },
    navStateRef(){
      return this.navState
    }
  },
  created() {
    this.adSingleCallback = this.createAdSingle()
  },
  methods: {
    // 点击标签页
    selectTab({name, index}) {
      this.dividerShowIndex = index
      const activeTab = this.navMenuTabs.find((tab) => tab.name === name);
      if (isMeaningful(activeTab)) {
        if (this.$route.fullPath !== activeTab.fullPath) {
          this.$router.push(activeTab.fullPath);
          // 在用户引导模式中，通过nav导航跳转视为自动退出指引模式
          if(this.userGuideState) {
            this.$store.commit(SET_USER_GUIDE_STATE, false);
          }
        }
      }
    },
    // 鼠标右键事件
    fixedTab(event, item) {
      this.mouseMenuOptions.item = item;
      this.mouseMenuStyle.top = event.pageY + "px";
      this.mouseMenuStyle.left = event.pageX + "px";
      this.mouseMenuOptions.fixed = item.fixed || false;
      this.changeMouseMenuShow(true);
    },
    // 改变鼠标右键菜单显示
    changeMouseMenuShow(type = false) {
      this.mouseMenuOptions.show = type;
    },
    // 改变任务栏固定
    changeTabFixed(data, type) {
      data.fixed = type;
      let navMenuTabs = this.navMenuTabs.filter((tab) => tab.fixed);
      storage.set("FIXED", navMenuTabs);
    },
    // 创建单例广告实例
    createAdSingle() {
      let instance = null
      return tabName => {
        if (!instance || !instance.modalVisible) {
          instance = this.$gjCreate('gj-info-modal', {
            props: {
              title: "确认取消",
              content: '一旦确认取消，编辑的广告内容将不会保存！是否要取消？',
            },
            mountTo: document.getElementById('gj-base-main'),
            on: {
              cancel: () => instance.$gjDestroy(),
              confirm: () => {
                instance = null
                this.removeTabCallback(tabName);
              },
            },
          });
        }
        return instance
      }
    },
    // 关闭标签页
    removeTab(tabName) {
      // 在用户引导模式中，通过nav导航跳转视为自动退出指引模式
      if(this.userGuideState) {
        this.$store.commit(SET_USER_GUIDE_STATE, false);
      }
      let ignore = sessionStorage.getItem("ignore"); // 0: 忽略 1：不忽略
      if (!["新增广告活动", "编辑广告活动"].includes(tabName) || ignore == 0) {
        sessionStorage.setItem("ignore", 1);
        this.removeTabCallback(tabName);
        return false;
      }
      this.adSingleCallback && this.adSingleCallback(tabName)
    },
    removeTabCallback(tabName, IsNextTab = true) {
      const index = this.navMenuTabs.findIndex((e) => e.name === tabName);
      if (index >= 0) {
        const nextTab =
          tabName === this.activeTabName ? this.navMenuTabs[index - 1] : null;
        // 移除组件缓存
        const keepAliveIndex = this.keepAliveViews.findIndex(
          (e) => e === this.navMenuTabs[index].componentName
        );
        if (keepAliveIndex > -1) {
          this.keepAliveViews.splice(keepAliveIndex, 1);
        }
        // 移除navTab
        this.navMenuTabs.splice(index, 1);
        if (isMeaningful(nextTab) && IsNextTab) {
          this.activeTabName = nextTab.name;
          this.$router.push(nextTab.fullPath);
        }
        this.setDividerShowIndex(this.$route)
      }
    },
    // 设置线条显示索引
    setDividerShowIndex(route) {
      const moduleRoute = route.matched[0];
      const navTab = this.navMenuTabs.find(
          (e) => e.name === moduleRoute.meta.name
        );
      if (navTab) {
        this.dividerShowIndex = this.navMenuTabs.findIndex(item => navTab.name === item.name)
      }
    },
    //   关闭所有标签
    closeAllTab() {
      const newTabs = [
        {
          fullPath: "/dashboard",
          name: "Dashboard",
          path: "/dashboard",
          closable: false,
          fixed: false,
        },
      ];
      this.$store.commit(SET_NAV_MENU_TABS, newTabs);
      this.$router.push("/");
      this.$store.commit(SET_KEEP_ALIVE_VIEWS, []);
      // 在用户引导模式中，通过nav导航跳转视为自动退出指引模式
      if(this.userGuideState) {
        this.$store.commit(SET_USER_GUIDE_STATE, false);
      }
    },
    //   关闭其他标签
    closeOtherTab() {
      const newTabs = [
        {
          fullPath: "/dashboard",
          name: "Dashboard",
          path: "/dashboard",
          closable: false,
        },
      ];
      if (this.activeTabName !== "Dashboard") {
        const activeTab = this.navMenuTabs.find(
          (tab) => tab.name === this.activeTabName
        );
        if (activeTab) {
          newTabs.push(activeTab);
          this.$store.commit(SET_KEEP_ALIVE_VIEWS, [activeTab.componentName]);
        }
      } else {
        this.$store.commit(SET_KEEP_ALIVE_VIEWS, []);
      }
      this.$store.commit(SET_NAV_MENU_TABS, newTabs);
      // divider样式控制
      this.dividerShowIndex = 0
    },
    // 刷新当前页
    refresh() {
      const tabName = this.mouseMenuOptions.item.name;
      const index = this.navMenuTabs.findIndex((e) => e.name === tabName);
      if (index >= 0) {
        // 移除组件缓存
        const keepAliveIndex = this.keepAliveViews.findIndex(
          (e) => e === this.navMenuTabs[index].componentName
        );
        keepAliveIndex > -1 && this.keepAliveViews.splice(keepAliveIndex, 1);
        this.$router.push({
          path: "/redirect",
          query: {
            url: this.mouseMenuOptions.item.fullPath,
          },
        });
      }
      // 在用户引导模式中，通过nav导航跳转视为自动退出指引模式
      if(this.userGuideState) {
        this.$store.commit(SET_USER_GUIDE_STATE, false);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.app-tab-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  position: sticky;
  top: 0;
  z-index: 999;
  // box-shadow: 4px 4px 6px #e4e5e6;
  /deep/ .el-tabs {
    width: 0;
    flex: 1;
  }
  .app-tab-bar__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 4px; // 用户名与页面的边距
    /deep/ .nav-bar--right__user--name,
    /deep/ .relate-us,
    /deep/ .el-icon-bell {
      color: #666666 !important;
    }
    .gj-dropdown{
      padding-right: 10px;
    }
  }
  /deep/ .el-tabs__nav {
    background: #fff;
  }
  
  /deep/ .el-tabs__item {
    padding: 0 !important;
    background: #F2F3F5;
    border: none !important;
    height: 30px;
    line-height: 30px;
    position: relative;
    .tab-bar-bg{
      height: auto;
      font-weight: 500;
      background: #fff;
      padding: 0 16px !important;
    }
    .tab-bar-bg:hover{
      // background: #EDF7FF;
      .label-temp{
        color: #1F6EEF;
      }
    }
    .label-temp{
      color: #666666;
    }
    .divider-vertical{
      position: absolute;
      top: 7px;
      right: 0;
      width: 1px;
      height: 16px;
      background: #E4E5E6;
    }
  }
    
  /deep/.is-active {
    .tab-bar-bg{
      color: #333333 ;
      background: #F2F3F5;
      border-radius: 4px;
    }
    .label-temp{
      // font-weight: 600;
      color: #1F6EEF;
    }
    .tab-bar-solid{
      background: white !important;
    }
    .divider-vertical{
      width: 0 !important;
    }
  }

  /deep/.el-icon-caret-bottom{
      font-size: 15px;
      font-weight: bold;
      color: #CDCDCD;
      &:hover{
        color: #1F6EEF;
      }
  }
  /deep/ .el-icon-arrow-left, /deep/ .el-icon-arrow-right{
    font-size: 14px;
    font-weight: bold;
    color: #CDCDCD;
    &:hover{
      color: #1F6EEF;
    }
  }
  
}

</style>
<style scoped>
.label-temp::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
>>> .el-tabs--card > .el-tabs__header {
  margin: 4px 0 0;
  padding: 0 10px 0 20px;
  border: none;
  max-width: 100%;
}
>>> .el-tabs__item {
  font-size: 13px !important;
  box-shadow: none !important;
  /* border: none !important; */
}
>>> .el-tabs__item .el-icon-close:hover {
  background: unset;
  color: #1F6EEF;
}
.tab--close__dropdown {
  /* position: fixed;
    top: 50px;
    right: 19px;
    font-size: 16px;
    cursor: pointer; */
}
.tab--close__dropdown:hover {
  color: #1F6EEF;
}
/deep/ .el-tabs__nav-wrap {
  padding-left: 0;
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item .el-icon-close {
  width: 14px !important;
}
/deep/.el-icon-paperclip::before {
  content: "\e6a3" !important;
}
.mouse-menu {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  padding: 8px 0;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0 0.5em 1em 0 rgb(0 0 0 / 10%);
  border-radius: 1px;
  color: #1a1a1a;
  font-size: 12px;
}
.mouse-menu .menu-mantle {
  z-index: 998;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.mouse-menu .menu-cell {
  z-index: 999;
  line-height: 33px;
  color: #606266;
  position: relative;
  padding: 0 20px;
  cursor: pointer;
}
.mouse-menu .menu-cell:hover {
  color: #5d9bfc;
  background-color: #edf7ff;
}
.menu-col {
  position: relative;
  line-height: 2.5;
  width: 180px;
  padding-left: 40px;
  box-sizing: border-box;
}
.menu-col-border {
  border-right: 1px solid rgba(246, 246, 248, .2)
}
.menu__module--title {
  font-weight: bold;
  color: #6e767e;
  font-size: 13px;
}
.menu__module--icon {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 8px;
  left: 14px;
}
.menu__route-link--label {
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
}
.menu__route-link {
  width: 100%;
  justify-content: flex-start;
  text-align: left;
}
.menu__route-link:hover .menu__route-link--label {
  color: white;
}
/deep/ .el-tabs__nav-next,
/deep/ .el-tabs__nav-prev {
  line-height: 32px;
}
.relate-us {
  cursor: pointer;
  color: #fff;
  /* margin-right: 14px;
    margin-bottom: 4px; */
  font-size: 16px;
  padding: 0 14px;
}

/deep/ .el-badge {
  vertical-align: baseline;
}

</style>
